/**
 * Section imagery for the Midpoint Media marketing Client View.
 * Files live in client/public/assets/midpoint-media/
 * Keep in sync with server/data/midpointMediaSectionImages.js
 */
const ASSET_BASE = `${process.env.PUBLIC_URL || ""}/assets/midpoint-media`;

export const MIDPOINT_MEDIA_SECTION_IMAGES = {
  hero: {
    url: `${ASSET_BASE}/simpler_map.png`,
    alt: "Abstract map visualization with signal markers representing market and location activity",
  },
  platform: {
    url: `${ASSET_BASE}/app_stack.png`,
    alt: "Layered platform view showing map context, data signals, and Client View experiences",
  },
  clientViews: {
    url: `${ASSET_BASE}/platform_screenshot.png`,
    alt: "Map-driven Client View with discovery, CRM intake, and market intelligence panels",
  },
  golfHomes: {
    url: `${ASSET_BASE}/golf_demo.png`,
    alt: "Golf Homes Client View map search for golf course communities and property opportunities",
  },
  casamapaCaseStudy: {
    url: `${process.env.PUBLIC_URL || ""}/client-views/casamapa/homepage_hero.png`,
    alt: "CasaMapa Client View map discovery for Colombia real estate, agencies, and community intelligence",
  },
  automapCaseStudy: {
    url: `${ASSET_BASE}/automap_case_study1.png`,
    alt: "AutoMapa Client View showing vehicle inventory search, dealer markers, and market pricing signals on a map",
  },
  systemizeFitCaseStudy: {
    url: `${ASSET_BASE}/systemize_fit_case_study.jpg`,
    alt: "Systemize Fit coaching workspace with trainer and client session context for programming, nutrition, and operations",
  },
  communityIntelligenceCaseStudy: {
    url: `${ASSET_BASE}/signal_intel_case_study.png`,
    alt: "Community Intelligence Client View with layered civic, safety, weather, and real estate signals on a neighborhood map",
  },
  hvacEcosystemCaseStudy: {
    url: `${ASSET_BASE}/hvac_ecosystem_case_study1.png`,
    alt: "HVAC Ecosystem Intelligence map showing contractor density, distributor coverage, and regional market scoring across the United States",
  },
  landHomesteadCaseStudy: {
    url: `${ASSET_BASE}/homestead_case_study.png`,
    alt: "Land and homestead Client View map with parcel boundaries, utility reach, and environmental risk overlays",
  },
  localBusinessCaseStudy: {
    url: `${ASSET_BASE}/business_case_study.png`,
    alt: "Local Business Map Client View with downtown district boundaries, business category pins, and sponsor placements",
  },
  consulting: {
    url: `${ASSET_BASE}/simple_map.png`,
    alt: "Geographic context map supporting consulting and platform implementation work",
  },
  contact: {
    url: `${ASSET_BASE}/simple_map.png`,
    alt: "Map-based operating picture for teams planning a new Client View",
  },
};

export const midpointMediaDefaultImages = Object.fromEntries(
  Object.entries(MIDPOINT_MEDIA_SECTION_IMAGES).map(([key, value]) => [key, value.url])
);
